var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settingslinks"},[_c('f-card',{staticClass:"f-card-double-padding"},[_c('div',{staticClass:"small-container"},[_c('p',{staticStyle:{"padding-bottom":"0"}},[_c('a',{attrs:{"href":_vm.explorerUrl,"rel":"noopener","target":"_blank"}},[_vm._v(" Fantom Explorer ")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }